module.exports = __webpack_public_path__ + "media/images/flags/ge-8868622314f074c60a3e74ada2630b24.svg";